var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a, _b;
import React, { useCallback } from "react";
import styled, { keyframes } from "styled-components";
import { SizeEnum, EmphasisEnum, EmphasisInverseEnum, ButtonVariantEnum, ThemeConstantEnum } from "../../enums";
import { RiLoader3Fill } from "@react-icons/all-files/ri/RiLoader3Fill";
var ButtonStyles = (_a = {},
    _a[EmphasisEnum.primary] = {
        button: {
            backgroundColor: EmphasisEnum.primary,
            borderColor: EmphasisEnum.primary,
            color: EmphasisInverseEnum.primary,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.primary,
            color: EmphasisEnum.primary,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.primary,
        },
    },
    _a[EmphasisEnum.secondary] = {
        button: {
            backgroundColor: EmphasisEnum.secondary,
            borderColor: EmphasisEnum.secondary,
            color: EmphasisInverseEnum.secondary,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.secondary,
            color: EmphasisEnum.secondary,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.secondary,
        },
    },
    _a[EmphasisEnum.tertiary] = {
        button: {
            backgroundColor: EmphasisEnum.tertiary,
            borderColor: EmphasisEnum.tertiary,
            color: EmphasisInverseEnum.tertiary,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.tertiary,
            color: EmphasisEnum.tertiary,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.tertiary,
        },
    },
    _a[EmphasisEnum.success] = {
        button: {
            backgroundColor: EmphasisEnum.success,
            borderColor: EmphasisEnum.success,
            color: EmphasisInverseEnum.success,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.success,
            color: EmphasisEnum.success,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.success,
        },
    },
    _a[EmphasisEnum.danger] = {
        button: {
            backgroundColor: EmphasisEnum.danger,
            borderColor: EmphasisEnum.danger,
            color: EmphasisInverseEnum.danger,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.danger,
            color: EmphasisEnum.danger,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.danger,
        },
    },
    _a[EmphasisEnum.warning] = {
        button: {
            backgroundColor: EmphasisEnum.warning,
            borderColor: EmphasisEnum.warning,
            color: EmphasisInverseEnum.warning,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.warning,
            color: EmphasisEnum.warning,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.warning,
        },
    },
    _a[EmphasisEnum.grey] = {
        button: {
            backgroundColor: EmphasisEnum.grey,
            borderColor: EmphasisEnum.grey,
            color: EmphasisInverseEnum.grey,
        },
        outline: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: EmphasisEnum.grey,
            color: EmphasisEnum.grey,
        },
        text: {
            backgroundColor: ThemeConstantEnum.transparent,
            borderColor: ThemeConstantEnum.transparent,
            color: EmphasisEnum.grey,
        },
    },
    _a);
var ColorAttribute;
(function (ColorAttribute) {
    ColorAttribute["backgroundColor"] = "backgroundColor";
    ColorAttribute["borderColor"] = "borderColor";
    ColorAttribute["color"] = "color";
})(ColorAttribute || (ColorAttribute = {}));
var getColorAttribute = function (attribute, props) {
    var emphasis = props.emphasis, variant = props.variant;
    if (typeof props[attribute] === "string") {
        return props[attribute];
    }
    return props.theme[ButtonStyles[emphasis][variant][attribute]]();
};
var ButtonSize = (_b = {},
    _b[SizeEnum.tiny] = {
        fontSize: 0.6,
        padding: ".3rem .5rem .3rem .5rem",
        borderRadius: "4px",
    },
    _b[SizeEnum.small] = {
        fontSize: 0.85,
        padding: ".4rem .7rem .4rem .7rem",
        borderRadius: "6px",
    },
    _b[SizeEnum.medium] = {
        fontSize: 1,
        padding: ".5rem 1rem .5rem 1rem",
        borderRadius: "8px",
    },
    _b[SizeEnum.large] = {
        fontSize: 1.25,
        padding: ".6rem 1.2rem .6rem 1.2rem",
        borderRadius: "9px",
    },
    _b[SizeEnum.giant] = {
        fontSize: 1.5,
        padding: ".7rem 1.5rem .7rem 1.5rem",
        borderRadius: "10px",
    },
    _b);
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return "\n      user-select: none;\n      align-items: center;\n      background-color: ".concat(props.isDisabled || props.isLoading
        ? props.theme.bgDisabled
        : getColorAttribute(ColorAttribute.backgroundColor, props), ";\n      border: 2px solid ").concat(props.isDisabled || props.isLoading
        ? props.theme.bgDisabled
        : getColorAttribute(ColorAttribute.borderColor, props), ";\n      border-radius: ").concat(ButtonSize[props.size].borderRadius, ";\n      color: ").concat(props.isDisabled || props.isLoading ? props.theme.colorDisabled : getColorAttribute(ColorAttribute.color, props), ";\n      display: flex;\n      font-size: ").concat(ButtonSize[props.size].fontSize, "rem;\n      justify-content: center;\n      line-height: ").concat(ButtonSize[props.size].fontSize, "rem;\n      padding: ").concat(props.variant === ButtonVariantEnum.text ? "0" : ButtonSize[props.size].padding, ";\n      height: ").concat(props.variant === ButtonVariantEnum.text
        ? ButtonSize[props.size].fontSize
        : ButtonSize[props.size].fontSize * 2, "rem;\n      cursor: ").concat(props.isLoading ? "wait" : props.isDisabled ? "not-allowed" : "pointer", ";\n      width: ").concat(props.variant === ButtonVariantEnum.text ? "unset" : "100%", ";\n\n      &:active {\n        transform: scale(.95);\n      }\n    ");
});
var LoaderAnimation = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0%, 20% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(180deg);\n  }\n"], ["\n  0%, 20% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(180deg);\n  }\n"])));
var LoaderIcon = styled(RiLoader3Fill)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 1s linear infinite;\n  margin-right: 5px;\n"], ["\n  animation: ", " 1s linear infinite;\n  margin-right: 5px;\n"])), LoaderAnimation);
var Button = function (_a) {
    var backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, color = _a.color, _b = _a.emphasis, emphasis = _b === void 0 ? EmphasisEnum.primary : _b, _c = _a.variant, variant = _c === void 0 ? ButtonVariantEnum.button : _c, children = _a.children, onClick = _a.onClick, _d = _a.size, size = _d === void 0 ? SizeEnum.medium : _d, type = _a.type, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, disabledMessage = _a.disabledMessage, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, loadingText = _a.loadingText, style = _a.style;
    var handleClick = useCallback(function (e) {
        if (isLoading) {
            e.preventDefault();
            return;
        }
        if (isDisabled) {
            e.preventDefault();
            if (disabledMessage !== undefined) {
                // todo - add toast with message
                console.log(disabledMessage);
            }
        }
        else if (onClick) {
            onClick(e);
        }
    }, [onClick, isLoading, isDisabled, disabledMessage]);
    return (React.createElement(StyledButton, { backgroundColor: backgroundColor, borderColor: borderColor, color: color, emphasis: emphasis, variant: variant, onClick: handleClick, size: size, type: type, isDisabled: isDisabled, isLoading: isLoading, style: style }, isLoading ? (React.createElement(React.Fragment, null,
        React.createElement(LoaderIcon, null),
        loadingText)) : (children)));
};
export default Button;
var templateObject_1, templateObject_2, templateObject_3;
